<template>
	<div class="question">
		<div class="q text_one"><span class="bg_theme">Q</span>{{ data.questionTitle }}<i :class="{'put_icon': expand,'expand_icon': !expand}" @click="toggleExpand"></i></div>
		<transition name="fade_transition">
			<div v-show="expand" class="a"><span>A</span><div v-html="data.answer"></div></div>
		</transition>
	</div>
</template>

<script>
	export default {
		props: {
			data: {
				type: Object,
				default() { return {}; }
			}
		},
		data() {
			return {
				expand: false
			}
		},
		methods: {
			toggleExpand() {
				this.expand = !this.expand;
			}
		}
	}
</script>

<style>
	.question{ padding: 28px 62px 12px 0;border-bottom: 1px dashed rgba(0, 0, 0, 0.2); }
	.question .q{ position: relative;height: 56px;padding: 0 33px 16px 60px;font-size: 20px;font-weight: bold;color: #333;line-height: 40px; }
	.question .q span{ display: block;position: absolute;width: 40px;height: 40px;top: 0;left: 0;border-radius: 50%;font-size: 24px;color: #fff;text-align: center;line-height: 40px; }
	.question .q .expand_icon{ display: block;position: absolute;width: 23px;height: 14px;top: 13px;right: 0;background-image: url(../../../../../../assets/expand.png);cursor: pointer; }
	.question .q .put_icon{ display: block;position: absolute;width: 23px;height: 14px;top: 13px;right: 0;background-image: url(../../../../../../assets/put.png);cursor: pointer; }
	.question .a{ position: relative;padding: 5px 0 42px 60px; }
	.question .a span{ display: block;position: absolute;width: 40px;height: 40px;top: 0;left: 0;border-radius: 50%;background: #ffb805;font-size: 24px;color: #fff;text-align: center;line-height: 40px; }
</style>
